export default __webpack_public_path__ + "static/media/legend-raster.3d07eec9.png";